// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"f16537cb","497":"a87fa35a","502":"39ee50c1"}[chunkId] + ".chunk.js";
};